<template>
  <div v-if="!IS_MOBILE_APP" class="flex justify-center items-center w-full gap-x-8">
    <a :href="link" target="_blank" rel="nofollow noopener">
      <StoreRating store="apple" class="border-r-2 border-gray-200 pr-8" />
    </a>
    <a :href="link" target="_blank" rel="nofollow noopener">
      <StoreRating store="google" />
    </a>
  </div>
</template>
<script lang="ts" setup>
const IS_MOBILE_APP = __IS_MOBILE_APP__
const link = useAppLink('app_ratings')
</script>
